<template>
	<el-dialog title="编辑运力车辆" v-model="isEdit" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container" style="max-height: 600px; overflow: auto">
			<p class="platTitle">基础信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">

					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>牵引车车辆</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="vehicleHeadId" placeholder="请选择">
								<el-option v-for="(item, index) in vehHeadList" :key="index" :label="item.vehNo"
									:value="item.vehId">
								</el-option>
							</el-select>
						</div>
						<!-- <div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;color: #606266;"
								v-model="driName" placeholder="请输入内容" />
							<div class="link-box" @click="vechlinkTap">
								<i class="el-icon-link"></i>关联车辆
							</div>
						</div> -->
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>挂车车辆:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="vehicleTailId" placeholder="请选择">
								<el-option v-for="(item, index) in vehTailList" :key="index" :label="item.vehNo"
									:value="item.vehId">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>驾驶员:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="vehicleMUserid" placeholder="请选择" @change="vehicleMUserChange">
								<el-option v-for="(item, index) in driList" :key="item.driUserId" :label="item.driName"
									:value="item.driUserId">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>押运员:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="vehicleYUserid" placeholder="请选择" @change="vehicleYUserChange">
								<el-option v-for="(item, index) in yyList" :key="item.yyUserId" :label="item.yyName"
									:value="item.yyUserId">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>驾驶员电话:</span>
						</div>
						<el-input v-model="vehicleMUserPhone" class="platItemRigth" placeholder="请输入" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>押运员电话:</span>
						</div>
						<el-input v-model="vehicleYUserPhone" class="platItemRigth" placeholder="请输入" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>运力来源:</span>
						</div>
						<div class="input_box">
							<el-select v-model="vehicleSource" placeholder="请选择车辆来源" @change="vehicleSourcechange">
								<el-option label="自有" value="0"> </el-option>
								<el-option label="外调" value="1"> </el-option>
								<el-option label="临时" value="2"> </el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>所属机构:</span>
						</div>
						<div class="input_box">
							<el-select v-model="vehicleAffOrg" placeholder="请选择所属客商" :disabled="vehicleOrgdisabled">
								<el-option v-for="item in ProviderList" :key="item.cocId" :label="item.cocName"
									:value="item.cocId" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>备注:</span>
						</div>
						<el-input v-model="vehicleRemark" class="platItemRigth" placeholder="请输入" />
					</div>

				</div>
			</div>

			<el-dialog title="关联车辆" v-model="isvechLink" width="50%" center>
				<div class="dialog-container">
					<div class="input-box flex flex-y-center" style="width: 300px">
						<el-input v-model="linkSearch" type="text" placeholder="请输入内容"></el-input>
						<div class="serach_btn" @click="getLinKData()">查询</div>
					</div>

					<div class="link-table m-top10" style="height: 300px; margin-top: 10px">
						<el-table stripe border style="width: 100%" height="300" v-bind:header-cell-style="{
			            textAlign: 'center',
			            color: '#333333',
			            background: '#F5F5F5',
			          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据" :data="tableData" ref="radioTable"
							@row-click="rowClick" @selection-change="selectionChange">
							<el-table-column type="selection"> </el-table-column>
							<el-table-column prop="applyPic" label="车辆照片">
								<template #default="scope">
									<img :src="scope.row.applyPic"
										style="width: 50px; height: 50px; border-radius: 10px" />
								</template>
							</el-table-column>
							<el-table-column prop="applyName" label="车牌号"> </el-table-column>

							<el-table-column prop="applyPhone" label="VIN" show-overflow-tooltip>
							</el-table-column>

							<el-table-column prop="address" label="地址" show-overflow-tooltip>
							</el-table-column>

							<el-table-column prop="applyTime" label="创建时间" show-overflow-tooltip>
							</el-table-column>
						</el-table>
						<el-pagination style="margin-top: 15px" background
							layout="sizes, prev, pager, next, total, jumper" v-bind:page-sizes="[10, 20, 50, 100]"
							:total="totalCount" v-model:current-page="currentPage" v-on:size-change="getLinKData()"
							v-on:current-change="getLinKData()" v-model:page-size="pageSize"></el-pagination>
					</div>
				</div>
				<template #footer>
					<span class="dialog-footer">
						<span class="btn btn-outline-default mr-50" v-on:click="closeModal()">取消</span>
						<span class="btn bg-default" v-on:click="addModal()">确定</span>
					</span>
				</template>
			</el-dialog>

			<span class="dialog-footer">
				<template v-if="pageType != 'detail'">
					<span class="btn btn-outline-default" v-on:click="closeModal()">取消</span>
					<span class="btn bg-default ml-50" v-on:click="submit()">确定</span>
				</template>
				<template v-else>
					<span class="btn bg-default" v-on:click="closeModal()">关闭</span>
				</template>
			</span>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";

	import "@riophae/vue-treeselect/dist/vue-treeselect.css";
	import * as imageConversion from "image-conversion";
	export default defineComponent({
		name: "Edit",
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				nextTick(() => {

					getVehHeadList();
					getVehTailList();
					getDirList();
					getYyList();
					getProviderList(); //获取客商
				});
			});
			const data = reactive({
				isEdit: false,
				treeData: [],
				roleList: [],
				vehHeadList: [],
				vehTailList: [],
				driList: [],
				yyList: [],
				ProviderList: [], //所属客商
				defaultProps: {
					children: "children",
					label: "text",
				},
				valueTitle: "",
				isShowTree: false,
				isvechLink: false, //关联车辆
				vehicleOrgdisabled: true,

				vehicleId: "",
				vehicleOrg: "", //所属机构
				vehicleAffOrg: "", //所属机构，外键，客商表或主机构表
				vehicleAffOrgType: "0", //所属机构类型：0客商机构1主机构
				vehicleSource: "0", //车辆来源
				vehicleOrgUsing: "", //机构级别 0本机构1本级及下级2本级及下级所有
				vehicleGroup: 1, //分组
				vehicleType: "1", //车辆类型
				vehicleHeadId: null, //牵引车辆
				vehicleTailId: null, //挂车车辆
				vehicleMUserid: null, //主驾驶员
				vehicleSUserid: null, //副驾驶员
				vehicleYUserid: null, //押运员
				vehicleHeadNo: "",
				vehicleTailNo: "",
				vehicleMUserName: "",
				vehicleYUserName: "",
				vehicleMUserPhone: "",
				vehicleYUserPhone: "",
				vehicleRemark: "",


			});
			//重置数据
			const init = async (id) => {
				data.isEdit = true;
				data.vehicleId = id;
				let params = {
					vehicleId: id,
				};
				const r = await proxy.$http.get(apiObj.vehicleDetail, params);
				if (r) {
					data.vehicleOrg = r.vehicle.vehicleOrg;
					data.vehicleOrgUsing = r.vehicle.vehicleOrgUsing;
					data.vehicleAffOrg = r.vehicle.vehicleAffOrg;
					data.vehicleAffOrgType = r.vehicle.vehicleAffOrgType;
					data.vehicleSource = r.vehicle.vehicleSource;
					data.vehicleGroup = r.vehicle.vehicleGroup;
					data.vehicleType = r.vehicle.vehicleType;
					data.vehicleHeadId = r.vehicle.vehicleHeadId;
					data.vehicleTailId = r.vehicle.vehicleTailId;
					data.vehicleMUserid = r.vehicle.vehicleMUserid;
					data.vehicleSUserid = r.vehicle.vehicleSUserid;
					data.vehicleYUserid = r.vehicle.vehicleYUserid;
					data.vehicleHeadNo = r.vehicle.vehHeadNo;
					data.vehicleTailNo = r.vehicle.vehTailNo;
					data.vehicleMUserName = r.vehicle.vehMDirName;
					data.vehicleYUserName = r.vehicle.vehYayunName;
					data.vehicleMUserPhone = r.vehicle.vehMDirPhone;
					data.vehicleYUserPhone = r.vehicle.vehYayunPhone;
					data.vehicleRemark = "";
				}

				if (data.vehicleSource == "0") {
					data.vehicleOrgdisabled = true;
				} else {
					data.vehicleOrgdisabled = false;
				}
			};

			//机构树
			const getTree = async () => {
				const r = await proxy.$http.post(apiObj.orgDeptTree, {});
				console.log(r);
				if (r) {
					let newArr = [];
					newArr.push(r);

					data.treeData = newArr;
					// nextTick(() => {
					//   proxy.$refs.tree.setCurrentKey(r.id);
					// });
				}
			};
			// 显示树形
			const showTree = () => {
				data.isShowTree = !data.isShowTree
			}
			//点击树形
			const handleNodeClick = (node) => {
				console.log(node);
				data.valueTitle = node.text;
				console.log(data.valueTitle);
				data.dataItem.deptNo = node.id;
				data.defaultExpandedKey = [];
			};
			// 上传图片
			const handleAddUploadChange = async (file) => {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					imageConversion.compress(file.raw, 0.6).then((res) => {
						imgFileToBase64({
							raw: res
						}, (imageUrl) => {
							data.dataItem.userHeadImg = imageUrl;
						});
					});
				} else {
					imgFileToBase64(file, (imageUrl) => {
						data.dataItem.userHeadImg = imageUrl;
					});
				}
			};
			//关联招聘
			const vechlinkTap = () => {
				data.isvechLink = true;
				//console.log(this.selectData);
				//this.getLinKData();
			};
			const getLinKData = () => {

			};
			const vehicleMUserChange = (value) => {
				const selectedItem = data.driList.find(item => item.driUserId === value);
				if (selectedItem) {
					data.vehicleMUserPhone = selectedItem.driPhone; // 更新其他参数的值。
				} else {
					data.vehicleMUserPhone = null; // 如果没有找到匹配项，则设置为null。
				}
			}
			const vehicleYUserChange = (value) => {
				const selectedItem = data.yyList.find(item => item.yyUserId === value);
				if (selectedItem) {
					data.vehicleYUserPhone = selectedItem.yyPhone; // 更新其他参数的值。
				} else {
					data.vehicleYUserPhone = null; // 如果没有找到匹配项，则设置为null。
				}
			}
			//选择主驾驶员
			const getDirList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "1000",
				};
				const r = await proxy.$http.get(apiObj.drigetList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.driList = r.driList;
				}
			};
			//选择押运员
			const getYyList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "1000",
				};
				const r = await proxy.$http.get(apiObj.yygetList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.yyList = r.yayunList;
				}
			};
			//选择牵引车辆
			const getVehHeadList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "1000",
				};
				const r = await proxy.$http.get(apiObj.vehGetHeadList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehHeadList = r.vehList;
				}
			};
			//选择挂车车辆
			const getVehTailList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "1000",
				};
				const r = await proxy.$http.get(apiObj.vehGetTailList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehTailList = r.vehList;
				}
			};
			const dialogClosedHandle = () => {
				data.isEdit = false;
			};
			const closeModal = () => {
				data.isEdit = false;
			};
			const submit = async () => {


				if (data.vehicleHeadId == "") {
					proxy.$message.error("请选择牵引车辆");
					return;
				}
				if (data.vehicleTailId == "") {
					proxy.$message.error("请选择挂车车辆");
					return;
				}

				let params = {
					vehicleId: data.vehicleId,
					vehicleOrg: data.vehicleOrg,
					vehicleAffOrg: data.vehicleAffOrg,
					vehicleAffOrgType: data.vehicleAffOrgType,
					vehicleSource: data.vehicleSource,
					vehicleOrgUsing: data.vehicleOrgUsing,
					vehicleGroup: data.vehicleGroup,
					vehicleType: data.vehicleType,
					vehicleHeadId: data.vehicleHeadId,
					vehicleTailId: data.vehicleTailId,
					vehicleMUserid: data.vehicleMUserid,
					vehicleSUserid: null,
					vehicleYUserid: data.vehicleYUserid
				}

				const r = await proxy.$http.post(apiObj.vehicleUpdate, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					data.isEdit = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}

			};
			const closeTree = () => {
				data.isShowTree = false
			};
			//获取所属客商
			const getProviderList = async () => {
				let params = {
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get(apiObj.cusList, params);
				console.log(res);
				if (res.code == 0) {
					data.ProviderList = res.rows;
				}
			};

			const vehicleSourcechange = () => {
				if (data.vehicleSource == "0") {
					data.vehicleAffOrg = "";
					data.vehicleAffOrgType = "1";
					data.vehicleOrgdisabled = true;
				} else {
					data.vehicleAffOrg = "";
					data.vehicleAffOrgType = "0";
					data.vehicleOrgdisabled = false;
				}
			}
			return {
				...toRefs(data),
				init,
				closeModal,
				vechlinkTap,
				getData,
				handleAddUploadChange,
				getTree,
				showTree,
				handleNodeClick,
				dialogClosedHandle,
				submit,
				closeTree,
				vehicleMUserChange,
				vehicleYUserChange,
				vehicleSourcechange
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		margin-left: 20px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		width: 77%;
		height: 35px;
		padding-left: 0px;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 80px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.link-box {
		margin-right: 10px;
		font-size: 14px;
		color: #5cc95e;
		cursor: pointer;
		width: 120px;
		text-align: right;
	}

	.vechName_input {
		border: none;
		outline: none;
		flex: 1;
		padding-left: 10px;
	}

	.serach_btn {
		width: 87px;
		height: 38px;
		background: #2EB779;
		border-radius: 6px;
		text-align: center;
		line-height: 38px;
		color: #fff;
		cursor: pointer;
		margin-left: 20px;
	}
</style>